import { NUMBER_REGEX } from 'src/app/shared/utils';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ClubService } from 'src/app/services/club.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SnackbarService } from '@services/snackbar.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';


@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss'],
  standalone: true,
  imports: [
    LottieComponent,
    MatFormFieldModule,
    MatIconModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule
  ],
})
export class AddCardComponent {
  public isUpdate = false;
  public membership: any;
  public showClubVerifyError = false;
  public clubForm = new UntypedFormGroup({
    clubCardID: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(NUMBER_REGEX),
      Validators.minLength(12),
    ]),
    phone: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(NUMBER_REGEX),
      Validators.minLength(10),
    ]),
  });

  public loading = false;
  public loadingText = '';

  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  constructor(
    private clubService: ClubService,
    private dialogRef: MatDialogRef<AddCardComponent>,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isUpdate = data?.isUpdate;
  }

  public async onValidateClubInfo(): Promise<void> {
    this.loading = true;
    this.loadingText = 'Validando...';
    try {
      const { data } = await this.clubService.getClubPointsByNumber(
        this.clubForm.get('clubCardID')?.value,
        this.clubForm.get('phone')?.value
      );
      this.membership = data;
      await this.clubService.setClubAlsuperCard({
        membership: this.clubForm.get('clubCardID')?.value,
        number: this.clubForm.get('phone')?.value
      });
      this.loading = false;
      this.clubService.reloadClubAlsuper$.emit(true);
      this.dialogRef.close();
      const modalData = {
        title: this.isUpdate ? '¡Tarjeta actualizada con éxito!' : '¡Tarjeta agregada con éxito!',
        subtitle: 'Comienza a realizar compras, acumula puntos y obtén los benificios exclusivos de Club Alsuper.',
        type: 'success',
        seeMyPoints: true
      };
      this.openModal(modalData);
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        if (error?.error?.data?.message === 'Limit of accounts connected for this membership.') {
          this.dialogRef.close();
          const modalData = {
            title: 'Límite de cuentas alcanzado',
            subtitle: 'La tarjeta Club Alsuper que intentas usar ya está registrada en 3 cuentas diferentes. Ingresa una tarjeta distinta para continuar.',
            type: 'warn',
            seeMyPoints: false
          };
          this.openModal(modalData);
        } else if (error?.error?.data?.membership_data?.message === 'Not same number') {
          this.dialogRef.close();
          const modalData = {
            title: 'Tarjeta incorrecta',
            subtitle: 'El número y tarjeta que has introducido no coindicen.',
            type: 'warn',
            seeMyPoints: false
          };
          this.openModal(modalData);
        }
        if (error?.error?.data?.message === 'Not same number') {
          this.showClubVerifyError = true;
        }
      }
      this.loading = false;
    }
  }

  private openModal(modalData: { title: string; subtitle: string; type: string; seeMyPoints: boolean; }): void {
    this.snackbarService.openResultsModal(modalData, {
      width: '360px',
      autoFocus: false,
      disableClose: true
    });
  }
}
